import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'react-hot-toast';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ResumeGeneratorPage from './pages/ResumeGeneratorPage';
import JobsPage from './pages/JobsPage';
import SettingsPage from './pages/SettingsPage';
import LandingPage from './pages/LandingPage';
import ApplicationsPage from './pages/ApplicationsPage';
import MyCVsPage from './pages/MyCVsPage';
import ProfileSetupPage from './pages/ProfileSetupPage';
import ApiDocsPage from './pages/ApiDocsPage';

// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';

function AppContent() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/api-docs" element={<ApiDocsPage />} />
        
        {/* Protected routes */}
        <Route path="/app" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="generate" element={<ResumeGeneratorPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="cvs" element={<MyCVsPage />} />
          <Route path="applications" element={<ApplicationsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="profile-setup" element={<ProfileSetupPage />} />
        </Route>
      </Routes>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Toaster position="top-right" />
        <AppContent />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;